import { AISuggestionProps } from '../../Types'
import { ReviseButton } from 'components/BlazeCommandLine/components/ReviseButton'
import { RevisionLevel, RevisionType } from 'components/BlazeCommandLine/Types'
import Styles from '../../AIRequestDrawer.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { useEffect, useMemo, useState } from 'react'
import { Tone } from 'components/VoiceAndTonesSelect/Types'
import { VoiceSelect } from './VoiceSelect'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useBrandVoices } from 'hooks/useBrandVoices'
import { MAX_INITIAL_PILLS } from 'components/DocRightRail/screens/AIAssistant/VoicesAndTonesSelect'
import { ToneSelect } from './ToneSelect'
import { More } from 'almanac-ui/icons'
import ListStyles from 'components/ListSelect/ListSelect.module.scss'
import { RevisionLevelSelect } from './RevisionLevelSelect'

export const EditTone = ({ articleId, layerId, editorState, onRevise, promptProps }: AISuggestionProps) => {
  const [tones, setSelectedTones] = useState<Tone[]>([])
  const [voice, setSelectedVoice] = useState<number>()
  const [revisionLevel, setRevisionLevel] = useState<RevisionLevel>(RevisionLevel.LIGHT)
  const currentWorkspace = useCurrentWorkspace()
  const voicesQuery = useBrandVoices(currentWorkspace)
  const voices = useMemo(() => voicesQuery.data ?? [], [voicesQuery])
  const [showAll, setShowAll] = useState(false)

  useEffect(() => {
    if (voices[0]) setSelectedVoice(voices[0].id)
  }, [voices])

  const someAndLessThanMaxVoices = voices.length > 0 && voices.length <= MAX_INITIAL_PILLS
  const moreThanMaxVoices = voices.length > MAX_INITIAL_PILLS

  return (
    <div className={Styles.suggestedAction}>
      <Text variant="placeholder" color="var(--dark-80)">
        Select your brand voice
      </Text>
      <div className={Styles.suggestedActionOptions}>
        <VoiceSelect selectedVoice={voice} onChange={setSelectedVoice} voices={voices} showAll={showAll} />
        {!showAll && (moreThanMaxVoices || someAndLessThanMaxVoices) && (
          <div className={ListStyles.listOption} onClick={() => setShowAll(true)}>
            <div className={ListStyles.icon}>
              <More />
            </div>
            <Text variant="largeList" color="var(--dark-80)">
              More...
            </Text>
          </div>
        )}
        {(showAll || (voicesQuery.isFetched && !voices.length)) && (
          <ToneSelect selectedTones={tones} onChange={setSelectedTones} />
        )}
      </div>

      <Text variant="placeholder" color="var(--dark-80)">
        What level of revisions would you like?
      </Text>

      <RevisionLevelSelect
        selectedLevels={[revisionLevel]}
        onChange={(selectedLevels) => setRevisionLevel(selectedLevels[0])}
      />

      <ReviseButton
        almanacEditorState={editorState}
        articleId={articleId}
        layerId={layerId}
        label="Edit Tone"
        onRevise={onRevise}
        prompt={{
          revision_type: RevisionType.CHANGE_TONE,
          brand_voice_id: voice,
          tone: tones,
          revision_level: revisionLevel,
        }}
        {...promptProps}
      />
    </div>
  )
}
